import { fromAPI } from "@cur8/rich-entity";
import { skipToken, useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { ExtractBody, ExtractKey, QueryOptions } from "typings/query";

export function useFetchSessionQuery<T = Body>({
  sessionId,
  siteId,
  options = {},
}: {
  sessionId: string | undefined;
  siteId: string;
  options?: QueryOptions<Body, Key, T>;
}) {
  const apiClient = useAPIClient();

  return useQuery({
    queryKey: queryKey(sessionId, siteId),
    queryFn: sessionId ? queryFn(apiClient, siteId, sessionId) : skipToken,
    ...options,
  });
}

const queryKey = (sessionId: string | undefined, siteId: string) => [
  "site",
  siteId,
  "session",
  sessionId,
];
const queryFn =
  (apiClient: APIClient, siteId: string, sessionId: string) => async () => {
    const response = await apiClient.siteCheckinSession.fetchSession({
      sessionId,
      siteId,
    }).result;
    return fromAPI.toCheckinSessionState(response);
  };

type Body = ExtractBody<typeof queryFn>;
type Key = ExtractKey<typeof queryKey>;
